// src/modules/app-views/invoices/pages/Init/components/tableColumns/operationNatureColumn.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Typography } from 'antd';
import translateX from 'utils/translateX';

const { Text } = Typography;

// *******************************************************************************
// COLUMN FUNCTION
// *******************************************************************************

// Renders operationNature column.
// options.rawText: false (default, invoices) — translates known values via translateX.
//                 true (goodsReceipt) — shows raw text from supplier NF.
function operationNatureColumn(buildColumnProps, options = {}) {
  const { rawText = false } = options;

  return {
    title: translateX('nature'),
    dataIndex: 'operationNature',
    ...buildColumnProps('operationNature', { sort: true }),
    width: 100,
    ellipsis: true,
    render: (_, record) => {
      const nature = record?.operationNature;
      if (!nature) return '—';
      return <Text>{rawText ? nature : translateX(nature)}</Text>;
    },
  };
}

export default operationNatureColumn;
